import { createSvgComponent } from "../../icon/createSvgComponent";
import Like from "@core/__generated__/icon/figma/like.svg";
export default createSvgComponent(Like);